import React, { memo } from 'react';
import { Controller } from 'react-hook-form';
import DatePicker from '../DatePicker';
import { EvaluationFieldProps } from '../../types/Evaluation';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  fieldLabel: {
      width: 160,
      fontSize: theme.typography.pxToRem(16),
      color: theme.palette.text.primary,
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginBottom: theme.spacing(0.5),
      },
    },
}), { name: 'DateInput' }); 

function DateInput({ name, control, label }: EvaluationFieldProps) {
  const classes = useStyles();

  function toLocalDateString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, onBlur } }) => (
        <>
        <Box className={classes.fieldLabel}>{label}:</Box>
        <DatePicker
          label={label}
          value={value || null}
          onChange={(dateValue) => {
            // Store date-only in local calendar format to avoid timezone day shifts.
            onChange(dateValue ? toLocalDateString(dateValue) : '');
          }}
          onBlur={onBlur}
        />
        </>
      )}
    />
  );
}

export default memo(DateInput);
